import Vue from 'vue'
import Router from 'vue-router'

// v1
// h5 upload video
import HomeV1 from '@/views/HomeV1.vue'
import Result from '@/views/Result.vue'
import HomeV2 from '@/views/HomeV2.vue'

// h5 upload image
import ImageHome from '@/views/upload-image/Home.vue'
import ImageDemo from '@/views/upload-image/demo.vue'
import ImageResult from '@/views/upload-image/Result.vue'

// pc
import pcHome from '@/views/pc/Home.vue'
import pcRecord from '@/views/pc/Record.vue'
import pcResult from '@/views/pc/Result.vue'


// v2
// h5 upload image
import ImageHomeV2 from '@/views/upload-image-v2/Home.vue'
import ImageResultV2 from '@/views/upload-image-v2/Result.vue'

// pc upload image
import webHomeV2 from '@/views/pc-v2/Home.vue'
import webResultV2 from '@/views/pc-v2/Result.vue'
import webFaceImageV2 from '@/views/pc-v2/FaceImage.vue'

Vue.use(Router)
export const PATH_PREFIX = '/client';
export default new Router({
  mode: 'history',
  routes: [
    // v2 -- begin
    {
      path: `/h5/index`,
      name: 'imageHomeV2',
      component: ImageHomeV2,
    },
    {
      path: `/h5/result`,
      name: 'ImageResultV2',
      component: ImageResultV2,
    },
    {
      path: `/web/index`,
      name: 'webHomeV2',
      component: webHomeV2,
    },
    {
      path: `/web/result`,
      name: 'webResultV2',
      component: webResultV2,
    },
    {
      path: `/web/RecordFace`,
      name: 'webFaceImageV2',
      component: webFaceImageV2,
    },
    // v2 --- end
    // v1 --- begin
    // h5
    {
      path: '/home-v1',
      name: 'homeV1',
      component: HomeV1,
    },
    {
      path: '/',
      name: 'homeV2',
      component: HomeV2,
    },
    {
      path: '/result',
      name: 'result',
      component: Result,
    },
    {
      path: '/photograph-flow',
      name: 'imageHome',
      component: ImageHome,
    },
    {
      path: '/photograph-flow-result',
      name: 'ImageResult',
      component: ImageResult,
    },
    {
      path: '/photograph-flow-demo',
      name: 'imageDemo',
      component: ImageDemo,
    },
    // pc
    {
      path: '/desktop.html',
      name: 'pcHome',
      component: pcHome,
    },
    {
      path: '/desktop',
      name: 'pcHome',
      component: pcHome,
    },
    {
      path: '/pc/record',
      name: 'pcRecord',
      component: pcRecord,
    },
    {
      path: '/pc/result',
      name: 'pcResult',
      component: pcResult,
    },
  ],
})
